import { gql } from "@apollo/client";

export const GET_COMPANY_BUSINESS_REGISTRATION = gql`
  query GetCompanyBusinessRegistration {
    getCompanyBusinessRegistration {
      success
      message
      data {
        id
        eInvoiceProvider
        crnNumber
        vatName
        vatNumber
        commercialName
        city
        citySubdivision
        street
        plotIdentification
        building
        postalZone
      }
    }
  }
`;

export const UPDATE_COMPANY_BUSINESS_REGISTRATION = gql`
  mutation UpdateCompanyBusinessRegistration($input: UpdateCompanyBusinessRegistrationInput!) {
    updateCompanyBusinessRegistration(input: $input) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`;
